module.exports = __webpack_public_path__ + "static/media/Flik8_index.45b31849.pdf";